import Warning from '@mui/icons-material/Warning';
import { Box, Button, Typography } from '@mui/material';
import { ETranscoderProfileKind, TranscoderProfile, TranscoderVideoProfile } from '@vxui/common';
import { Modal } from '@vxui/components';
import { FC, ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TMutationTrigger } from './useActionModal';

type Modal = {
  onDeleteHandler: (row: TranscoderVideoProfile) => void;
  component: ReactElement;
};

type SingleDeleteProfileModalProps = {
  profile: TranscoderProfile | undefined;
  kind: ETranscoderProfileKind;
  onClose: () => void;
  clearSelectableRows: () => void;
  deleteAction: TMutationTrigger;
};

export const SingleDeleteProfileModal: FC<SingleDeleteProfileModalProps> = ({
  profile,
  kind,
  onClose,
  clearSelectableRows,
  deleteAction,
}) => {
  const { t } = useTranslation();
  const isUsed = !!(profile?.templates && profile.templates.length > 0);

  const onDeleteConfirmHandler = async (): Promise<void> => {
    if (profile) {
      await deleteAction(profile.id);
      clearSelectableRows();
      onClose();
    }
  };
  return (
    profile && (
      <Modal
        open={!!profile}
        maxWidth="sm"
        onClose={onClose}
        title={t(`transcoder.modal.delete.${kind}Profile.title`)}
        actions={
          <Box>
            <Button
              size="medium"
              variant="outlined"
              color="secondary"
              sx={{ marginRight: isUsed ? '0' : '15px' }}
              onClick={onClose}
            >
              {isUsed ? t('button.close') : t('button.cancel')}
            </Button>
            {!isUsed && (
              <Button size="medium" variant="contained" color="error" onClick={onDeleteConfirmHandler}>
                {t('button.delete')}
              </Button>
            )}
          </Box>
        }
      >
        <Typography variant="p16" component="span" color={isUsed ? 'warning' : undefined}>
          {isUsed ? (
            <Box display="flex" flexDirection="row" alignItems="flex-start" gap="16px">
              <Warning color="warning" fontSize="medium" />
              <Box>
                <Trans i18nKey={`transcoder.modal.delete.${kind}Profile.descriptionInUse`} values={profile} />
              </Box>
            </Box>
          ) : (
            <Trans i18nKey={`transcoder.modal.delete.${kind}Profile.description`} values={profile} />
          )}
        </Typography>
      </Modal>
    )
  );
};
